import * as R from 'ramda';

export const formatNumberToRu = (num: any, minDecimal: number, maxDecimal?: number) =>
    typeof num === 'number'
        ? new Intl.NumberFormat('ru', {
              minimumFractionDigits: minDecimal,
              maximumFractionDigits: maxDecimal ?? minDecimal,
          }).format(num)
        : num;

export const formatNumberToRuF = R.flip(formatNumberToRu);

export const fromNumberToStrWithGrouping = (
    o: number,
    payload?: {
        withRublesSign?: boolean;
        minimumFractionDigits?: number;
    },
) => {
    if (payload?.withRublesSign) {
        const options: any = { style: 'currency', currency: 'RUB' };

        if (typeof payload?.minimumFractionDigits === 'number') {
            options.minimumFractionDigits = payload.minimumFractionDigits;
            options.maximumFractionDigits = payload.minimumFractionDigits;
        }

        return o.toLocaleString('ru-RU', options);
    }
    const options: any = { useGrouping: true, maximumFractionDigits: 2 };

    if (typeof payload?.minimumFractionDigits === 'number') {
        options.minimumFractionDigits = payload.minimumFractionDigits;
    }

    return o.toLocaleString('ru-RU', options);
};
